import { render } from "./TemplateSix.vue?vue&type=template&id=4a334ca3"
import script from "./TemplateSix.vue?vue&type=script&lang=js"
export * from "./TemplateSix.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__